<!-- 
<div *ngIf="loading" class="flex items-center justify-center h-screen bg-white">
  <div class="flex flex-col items-center space-y-2">
    <div class="w-6 h-6 border-2 border-gray-100 border-t-blue-600 rounded-full animate-spin"></div>
    <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Loading</span>
  </div>
</div>

<form *ngIf="!loading && form" [formGroup]="form" class="flex flex-col h-screen bg-white font-sans text-gray-800">

  <div
    class="flex-none bg-white border-b border-gray-100 px-6 py-2.5 flex items-center justify-between sticky top-0 z-50">
    <div class="flex items-center gap-3">
      <h3 class="text-[13px] font-bold text-gray-900 uppercase tracking-tight">
        {{ layout.name || 'General Settings' }}
      </h3>
      <span *ngIf="recordId"
        class="px-1.5 py-0.5 bg-blue-50 text-blue-600 text-[9px] font-black uppercase tracking-tighter rounded border border-blue-100">
        Edit Mode
      </span>
    </div>
  </div>

  <div class="flex-grow overflow-y-auto custom-scrollbar">
    <div class="w-full max-w-[1200px] mx-auto px-3 py-2">

      <div class="mb-4">
        <app-dynamic-form-shell [layout]="layout" [form]="form">
        </app-dynamic-form-shell>
      </div>

      <div *ngIf="recordId" class="mt-12 pt-6 border-t border-gray-100">
        <h4 class="text-sm font-bold text-gray-900 mb-2">Delete Account</h4>
        <p class="text-[13px] text-gray-600 leading-relaxed mb-4 max-w-2xl">
          We regret to see you leave. Confirm account deletion below. Your data will be permanently removed.
          Thank you for being part of our community.
        </p>
        <div class="flex items-center gap-3">
          <button type="button"
            class="px-4 py-2 bg-white border border-gray-200 text-gray-700 text-[11px] font-bold uppercase tracking-widest rounded hover:bg-gray-50 transition-all">
            Deactivate Instead
          </button>
          <button type="button" (click)="delete()"
            class="px-4 py-2 bg-red-600 text-white text-[11px] font-bold uppercase tracking-widest rounded hover:bg-red-700 shadow-sm transition-all">
            Delete Account
          </button>
        </div>
      </div>

    </div>
  </div>

  <div class="flex-none bg-white border-t border-gray-100 px-6 py-3 sticky bottom-0 z-50">
    <div class="w-full max-w-[1200px] mx-auto flex items-center justify-between">

      <button type="button" (click)="form.reset()"
        class="text-[11px] font-bold text-gray-400 hover:text-red-500 uppercase tracking-widest transition-colors focus:outline-none">
        Discard Changes
      </button>

      <div class="flex items-center gap-2">

        <button type="button" (click)="recordId ? update() : save()"
          class="px-8 py-2.5 text-[11px] font-bold text-white bg-black rounded-lg hover:bg-gray-800 transition-all shadow-md uppercase tracking-widest active:scale-95">
          {{ recordId ? 'Save Changes' : 'Submit' }}
        </button>
      </div>
    </div>
  </div>
</form> -->

<div *ngIf="loading" class="flex items-center justify-center h-screen bg-white">
  <div class="flex flex-col items-center space-y-2">
    <div class="w-6 h-6 border-2 border-gray-100 border-t-blue-600 rounded-full animate-spin"></div>
    <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400">Loading</span>
  </div>
</div>

<form *ngIf="!loading && form" [formGroup]="form" class="flex flex-col h-screen bg-white font-sans text-gray-800">

  <div
    class="flex-none bg-white border-b border-gray-100 px-6 py-2 flex items-center justify-between sticky top-0 z-50">

    <div class="flex items-center gap-3">
      <h3 class="text-[12px] font-extrabold text-gray-900 uppercase tracking-tight">
        {{ layout.name || 'General Settings' }}
      </h3>
      <span *ngIf="recordId"
        class="px-1.5 py-0.5 bg-blue-50 text-blue-600 text-[9px] font-black uppercase tracking-tighter rounded border border-blue-100">
        Edit Mode
      </span>
    </div>

    <!-- <div class="flex items-center gap-2">
      <button type="button" (click)="recordId ? update() : save()"
        class="px-6 py-2 text-[10px] font-bold text-white bg-black rounded-md hover:bg-gray-800 transition-all shadow-sm uppercase tracking-widest active:scale-95">
        {{ recordId ? 'Save Changes' : 'Submit' }}
      </button>
      <button type="button" (click)="backToList()"
        class="flex items-center gap-2 px-4 py-2 bg-[#F5F8FA] text-[#5E6278] hover:bg-[#E4E6EF] hover:text-[#000000] text-[10px] font-bold uppercase tracking-widest rounded transition-all group">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 transition-transform group-hover:-translate-x-0.5"
          fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M15 19l-7-7 7-7" />
        </svg>
        Back to List
      </button>
      <button type="button" (click)="form.reset()"
        class="px-3 py-2 text-[10px] font-bold text-gray-400 hover:text-red-500 uppercase tracking-widest transition-colors focus:outline-none">
        Clear All
      </button>
    </div> -->

    <app-transaction-toolbar
      [actions]="layout.actions || []"
      [form]="form"
      [entity]="entity"
      [layout]="layout"
      [recordId]="recordId">
    </app-transaction-toolbar>

  </div>

  <div class="flex-grow overflow-y-auto custom-scrollbar">
    <div class="w-full max-w-[1200px] mx-auto px-6 py-4">

      <div class="mb-4">
        <app-dynamic-form-shell [layout]="layout" [form]="form">
        </app-dynamic-form-shell>
      </div>

      <!-- <div *ngIf="recordId" class="mt-10 pt-6 border-t border-gray-100">
        <h4 class="text-[12px] font-bold text-gray-900 mb-1">Delete Account</h4>
        <p class="text-[12px] text-gray-500 mb-4 max-w-2xl">
          Confirmation is required for permanent data removal.
        </p>
        <button type="button" (click)="delete()"
          class="px-4 py-2 bg-red-600 text-white text-[10px] font-bold uppercase tracking-widest rounded hover:bg-red-700 transition-all">
          Confirm Deletion
        </button>
      </div> -->

    </div>
  </div>

  <div *ngIf="
        layout?.taxConfig
          ?.enabled
      "
      class="hidden kt-drawer kt-drawer-end card flex-col max-w-[90%] top-5 bottom-5 end-5 rounded-xl border border-border"
      data-kt-drawer="true"
      data-kt-drawer-container="body"
      id="drawer_tax_breakdown">

      <app-tax-breakdown-drawer
        [lines]="getTaxRepeater()"
        [summary]="getTaxSummary()">
      </app-tax-breakdown-drawer>

    </div>

</form>